import { connect } from 'react-redux';
import { loadDataCredentials } from '../../../../actions';
import TemplatizedScriptSourceConfiguration from './TemplatizedScriptSourceConfiguration';

const mapStateToProps = (state, ownProps) => {
  const {
    entities: { credentials },
    credentials: { lastUpdated },
  } = state;

  return {
    credentials,
    credentialsLoaded: !!lastUpdated,
  };
};

export default connect(mapStateToProps, {
  loadDataCredentials,
})(TemplatizedScriptSourceConfiguration);
